import { Modal, FormGroup, FormControl, Row, Col, Button, FormLabel } from "react-bootstrap";
import { Formik, FieldArray } from "formik";
import { useState, useEffect, Fragment } from "react";
import { useSelector, useDispatch  } from "react-redux";
import useFullPageLoader from "app/hooks/useFullPageLoader ";
import { Card, Table } from "react-bootstrap";
import { format } from "date-fns";
import Select from 'react-select'
import { useLazyGetCRMCustomerDetailsListQuery } from "app/redux/Customer/customerApi";
import {useLazyAddDirectUsersQuery  } from "app/redux/AMS/amsApi";
import AddCustomerModal from "app/views/dashboard/modal/AddCustomerModal";
import {PersonAdd} from "react-bootstrap-icons";

export default function AddDirectUser({
    show,
    handleDirectUserFormSubmit,
    toggleDirectUserEditorDialog,
    initialValues = {}
  }) 
  {
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [customerFullDetailList, setCustomerFullDetailListState] = useState([]);
    let [customerDetailList, setCustomerDetailListState] = useState([]);
    const[listOfUsers, setState] = useState([]);
    const [addCustomerModalState, setAddCustomerModalState] = useState({
      addCustomerdialogValues: null,
      addCustomershowEditorDialog: false
    });
   
    const { selectedCompanyId } = useSelector((state) => state.company);
    const [getCRMCustomerDetailsList] = useLazyGetCRMCustomerDetailsListQuery();
    const [addDirectUsers] = useLazyAddDirectUsersQuery();
    //let listOfUsers = [];
    useEffect(() => {
      setState([]);
    }, [show]);

    useEffect(() => {
      fetchCRMCustomerDetailsList(0);
    }, [initialValues]);


    const handleDeleteCustomer = async (itemIndx, customerId) => {
      let ownerdet = listOfUsers;//state.item;
      if(ownerdet && ownerdet.length > 0){
        ownerdet = ownerdet.filter(a => a.CustomerId !== customerId);
        setState(ownerdet);
      }
      ownerdet.slice(itemIndx,1);
      //setState(listOfUsers);
    //   setState({
    //     item: ownerdet
    //   });
    };

    const onChange = (event) => {
     if(event){
        customerDetailList = customerDetailList.filter(a => a.CustomerId !== event.CustomerId);
        setCustomerDetailListState(customerDetailList);
        let ownerdet = listOfUsers;//state.item;state.listOfUsers;
        let tempval = {};
        tempval.CustomerId = event.CustomerId
        tempval.name =event.CustomerNickName;
        tempval.email = event.PrimaryEmail;
        tempval.phone = event.PrimaryPhone;
        ownerdet.push(tempval);
        // listOfUsers = ownerdet;
        setState(ownerdet);
        // setState({
        //     listOfUsers: ownerdet
        // });
     }
    };

    
    const handleSubmit = async (e) => {
        showLoader();
        let obj = {};
        obj["companyId"] = localStorage.getItem('CompanyId');
        if(initialValues.vendorAccessGroupId){
            obj.vendorAccessGroupId = initialValues.vendorAccessGroupId;
        }
        if(initialValues.accessGroupType){
            obj.accessType = initialValues.accessGroupType;
        }
        obj["createdBy"] = localStorage.getItem("loginUserPersonId") ?? "0";
        let objUsers = [];
        listOfUsers.forEach((item) => {
            let tempObj = {};
            tempObj.id = item.CustomerId;
            tempObj.name = item.name;
            tempObj.phone = item.phone;
            tempObj.email = item.email;
            objUsers.push(tempObj);
        })
        obj.listOfUsers = objUsers;
        //console.log('addDirectUsers -- ', obj);
        await addDirectUsers(obj).then((result) => {
            hideLoader()
            if(result.isSuccess){
                handleDirectUserFormSubmit(initialValues);
                toggleDirectUserEditorDialog();
            }
        }, error => {
        hideLoader();
        });
    }

    const addCustomerToggleEditorDialog = (arg) => {
      if (arg && arg.toString()) {
          setAddCustomerModalState((prevState) => ({ ...prevState, addCustomershowEditorDialog: true, addCustomerdialogValues: null }));
      } else {
          setAddCustomerModalState((prevState) => ({
          ...prevState,
          addCustomerdialogValues: null,
          addCustomershowEditorDialog: !addCustomerModalState.addCustomershowEditorDialog
          }));
      }
    };

    const fetchCRMCustomerDetailsList = async(custId, type="") => {
      showLoader();
      getCRMCustomerDetailsList({
          CompanyId: selectedCompanyId,
          CustomerType: 3,
          IsArchive: false,
          ContractTypeID: 0
        }).then((result) => {
          hideLoader();
          if (result.isSuccess) {
            let tempdata = result.data.data;
            let customerData = tempdata.map((e) => ({
              ...e,
              value: e.CustomerId,
              label: e.ContactName
            }));
            //console.log('customerdata -- ', customerData);
            if(custId && custId !== 0){
              setDirectUser(custId, customerData, "New");
            }
            setCustomerFullDetailListState(customerData);
            setCustomerDetailListState(customerData);
          }
        });
    }

    const setDirectUser = (custId, customerData, type) => {
      if(custId && custId !== 0){
          let selectedCustDetail = customerData.filter(a => a.CustomerId === custId);
          if(selectedCustDetail && selectedCustDetail.length > 0){
              let ownerdet = listOfUsers;
              if(ownerdet && ownerdet.length > 0){
                const chkAlreadyExists = ownerdet.filter(a => a.CustomerID === custId);
                if(chkAlreadyExists && chkAlreadyExists.length > 0){
                  return;
                }
              }
              let tempval = {};
              tempval.CustomerId = selectedCustDetail[0].CustomerId
              tempval.name =selectedCustDetail[0].CustomerNickName;
              tempval.email = selectedCustDetail[0].PrimaryEmail;
              tempval.phone = selectedCustDetail[0].PrimaryPhone;
              tempval.IsPrivateCustomer = true;
              tempval.CustomerNumber = selectedCustDetail[0].CustomerNumber;
              tempval.customerNickName = selectedCustDetail[0].CustomerNickName;
              tempval.CustomerAccountingId = selectedCustDetail[0].CustomerAccountingId;
              tempval.ContractPerson = selectedCustDetail[0].ContactName;
              tempval.ContactId = selectedCustDetail[0].ContactID;
              tempval.PersonNumber = selectedCustDetail[0].PersonNumber;
              tempval.IsPostalAddress = true;
              tempval.AddressLine1 = selectedCustDetail[0].PrimaryAddressLine1;
              tempval.AddressLine2 = selectedCustDetail[0].PrimaryAddressLine2;
              tempval.PostalCode = selectedCustDetail[0].PrimaryZipCode;
              tempval.City = selectedCustDetail[0].PrimaryCity;
              tempval.Country = selectedCustDetail[0].PrimaryCountry;
              tempval.bankAccountNumber = selectedCustDetail[0].BankAccountNo;
              tempval.IsCustomer = selectedCustDetail[0].IsCustomer;
              ownerdet.push(tempval);
              setState(ownerdet);
              
          }
          
       }
    }

    const addCustomerHandleFormSubmit = async (values) => {
      //console.log('addCustomerHandleFormSubmit - ', values);
      fetchCRMCustomerDetailsList(values);
      addCustomerToggleEditorDialog(false);
    };

    let { addCustomerdialogValues, addCustomershowEditorDialog } = addCustomerModalState;
    return (
        <Fragment>
          {
              !addCustomershowEditorDialog &&
              <div>
              <Modal show={show} onHide={toggleDirectUserEditorDialog} size="lg" className="mt-0">
          <div className="modal-header d-flex justify-content-between align-items-center">
            <h5 className="modal-title" id="exampleModalLabel">
              Ny bruker
            </h5>
    
            <span
              className="close fw-bold fs-3 cursor-pointer"
              aria-label="Close"
              onClick={() => toggleDirectUserEditorDialog(false)}>
              <span aria-hidden="true">&times;</span>
            </span>
          </div>
    
          <div className="modal-body">
          <Row>
          <Col xs={12}>
                        <Table bordered className="tbl-custom" >
                          <thead style={{borderTop: "1px solid #eeeeee", whiteSpace: "nowrap"}}>
                            <tr>
                              <th className="py-3">#</th>
                              <th className="py-3" align="left">
                                Navn
                              </th>
                              <th className="py-3" align="left">
                                E-post
                              </th>
                              <th className="py-3" align="left">
                                Telefon
                              </th>
                              <th ></th>
                            </tr>
                          </thead>

                          <tbody>
                            {listOfUsers.map((item, ind) => (
                              <tr key={ind}>
                                <th className="text-middle" scope="row">
                                  {ind + 1}
                                </th>
                                <td>
                                    {item.name}
                                  {/* <FormControl
                                    value={values.listOfUsers[ind].name}
                                    name={`listOfUsers[${ind}].name`}
                                    type="text"
                                    placeholder="Navn"
                                    disabled="true"
                                  /> */}
                                </td>
                                <td>
                                    {item.email}
                                  {/* <FormControl
                                    value={values.listOfUsers[ind].email}
                                    name={`listOfUsers[${ind}].email`}
                                    type="text"
                                    placeholder="e-post"
                                    disabled="true"
                                  /> */}
                                </td>
                                <td>
                                    {item.phone}
                                  {/* <FormControl
                                    value={values.listOfUsers[ind].phone}
                                    name={`listOfUsers[${ind}].phone`}
                                    type="text"
                                    placeholder="telefon"
                                    disabled="true"
                                  /> */}
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={() => handleDeleteCustomer(ind, item.CustomerId)}
                                    className="btn btn-outline-secondary float-right">
                                    Delete
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>

                        {listOfUsers.length === 0 && (
                          <small className="text-danger">Minimum 1 item is required</small>
                        )}
                      </Col>
                 </Row>
                 
                <Row className="mt-2 mb-3">
                        <FormGroup as={Col} xs={3} className="d-flex flex-column"> 
                            <Button variant="primary" onClick={addCustomerToggleEditorDialog}>
                                <PersonAdd className={'me-2'} size={17}></PersonAdd>
                                  Legg til ny eier
                            </Button>
                        </FormGroup> 
                         <FormGroup as={Col} xs={6} className="d-flex flex-column"> 
                                <Select
                                  placeholder={"Select user"}
                                  aria-labelledby="aria-label"
                                  inputId="aria-example-input"
                                  name="aria-live-color"
                                  onChange={onChange}
                                  options={customerDetailList}
                                />
                          </FormGroup> 
                 </Row>
                 <Modal.Footer className={''}>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => toggleDirectUserEditorDialog(false)}>
                      Lukke
                    </button>

                    <button type="submit" className="btn btn-primary"
                       onClick={() => handleSubmit()}
                      >
                      Save changes
                    </button>
                  </Modal.Footer>
          </div>
          
          {loader}
         
        </Modal>
        </div> 
          }
          {
            addCustomershowEditorDialog && 
            <AddCustomerModal
            show={addCustomershowEditorDialog}
            initialValues={addCustomerdialogValues}
            handleFormSubmit={addCustomerHandleFormSubmit}
            toggleEditorDialog={addCustomerToggleEditorDialog}
            />
          }
          

        </Fragment>
        // <Modal show={show} onHide={toggleDirectUserEditorDialog} size="lg" className="mt-0">
        //   <div className="modal-header d-flex justify-content-between align-items-center">
        //     <h5 className="modal-title" id="exampleModalLabel">
        //         Nytt eierskap
        //     </h5>
    
        //     <span
        //       className="close fw-bold fs-3 cursor-pointer"
        //       aria-label="Close"
        //       onClick={() => toggleDirectUserEditorDialog(false)}>
        //       <span aria-hidden="true">&times;</span>
        //     </span>
        //   </div>
    
        //   <div className="modal-body">
        //   <Row>
        //   <Col xs={12}>
        //                 <Table bordered className="tbl-custom" >
        //                   <thead style={{borderTop: "1px solid #eeeeee", whiteSpace: "nowrap"}}>
        //                     <tr>
        //                       <th className="py-3">#</th>
        //                       <th className="py-3" align="left">
        //                         Navn
        //                       </th>
        //                       <th className="py-3" align="left">
        //                         E-post
        //                       </th>
        //                       <th className="py-3" align="left">
        //                         Telefon
        //                       </th>
        //                       <th ></th>
        //                     </tr>
        //                   </thead>

        //                   <tbody>
        //                     {listOfUsers.map((item, ind) => (
        //                       <tr key={ind}>
        //                         <th className="text-middle" scope="row">
        //                           {ind + 1}
        //                         </th>
        //                         <td>
        //                             {item.name}
        //                           {/* <FormControl
        //                             value={values.listOfUsers[ind].name}
        //                             name={`listOfUsers[${ind}].name`}
        //                             type="text"
        //                             placeholder="Navn"
        //                             disabled="true"
        //                           /> */}
        //                         </td>
        //                         <td>
        //                             {item.email}
        //                           {/* <FormControl
        //                             value={values.listOfUsers[ind].email}
        //                             name={`listOfUsers[${ind}].email`}
        //                             type="text"
        //                             placeholder="e-post"
        //                             disabled="true"
        //                           /> */}
        //                         </td>
        //                         <td>
        //                             {item.phone}
        //                           {/* <FormControl
        //                             value={values.listOfUsers[ind].phone}
        //                             name={`listOfUsers[${ind}].phone`}
        //                             type="text"
        //                             placeholder="telefon"
        //                             disabled="true"
        //                           /> */}
        //                         </td>
        //                         <td>
        //                           <button
        //                             type="button"
        //                             onClick={() => handleDeleteCustomer(ind, item.CustomerId)}
        //                             className="btn btn-outline-secondary float-right">
        //                             Delete
        //                           </button>
        //                         </td>
        //                       </tr>
        //                     ))}
        //                   </tbody>
        //                 </Table>

        //                 {listOfUsers.length === 0 && (
        //                   <small className="text-danger">Minimum 1 item is required</small>
        //                 )}
        //               </Col>
        //          </Row>
                 
        //         <Row className="mt-2 mb-3">
        //                   <FormGroup as={Col} xs={2} className="d-flex flex-column"> 
        //                       <Button variant="primary" onClick={addCustomerToggleEditorDialog}>
        //                           <PersonAdd className={'me-2'} size={17}></PersonAdd>
        //                             Legg til ny eier
        //                       </Button>
        //                   </FormGroup> 
        //                  <FormGroup as={Col} xs={6} className="d-flex flex-column">  */}
        //                         <Select
        //                           placeholder={"Select user"}
        //                           aria-labelledby="aria-label"
        //                           inputId="aria-example-input"
        //                           name="aria-live-color"
        //                           onChange={onChange}
        //                           options={customerDetailList}
        //                         />
        //                   </FormGroup> 
        //          </Row>
        //          <Modal.Footer className={''}>
        //             <button
        //               type="button"
        //               className="btn btn-secondary"
        //               onClick={() => toggleDirectUserEditorDialog(false)}>
        //               Lukke
        //             </button>

        //             <button type="submit" className="btn btn-primary"
        //                onClick={() => handleSubmit()}
        //               >
        //               Save changes
        //             </button>
        //           </Modal.Footer>
        //   </div>
          
        //   {loader}

        //   <AddCustomerModal
        //         show={addCustomershowEditorDialog}
        //         initialValues={addCustomerdialogValues}
        //         handleFormSubmit={addCustomerHandleFormSubmit}
        //         toggleEditorDialog={addCustomerToggleEditorDialog}
        //   />
        // </Modal>
        
      );
  }


